// @core/api/endpoints/team/get_team_user_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamUserSettingsResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get team user settings
 * Retrieves team user settings by the specified identifier.
 */
export async function GetTeamUserSettings(
  team_id: string,
  options?: RequestOptions
): Promise<GetTeamUserSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/user`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<GetTeamUserSettingsResponse>(requestPath, { ...requestOptions });
}
